import { Avatar, Stack, Typography } from '@mui/material';
import { slashDateFormat } from 'Config';
import { format } from 'date-fns/esm';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';
import { RegularCalendar } from 'Images';

interface ILastUpdated {
  lastUpdateDate?: Date;
}

export const LastUpdated = ({ lastUpdateDate }: ILastUpdated) => {
  const isDesktop = useIsDesktop();

  return (
    <Stack
      gap={'6px'}
      direction={'row'}
      alignItems={'center'}
      width={'fit-content'}
    >
      {!isDesktop && (
        <Avatar
          alt=''
          src={RegularCalendar}
          sx={{ width: '20px', height: '20px' }}
        />
      )}
      <Typography variant={'body3'} whiteSpace={'nowrap'}>
        {Dictionary[DICTIONARY.CompassRights].compassRightsHeader.lastUpdated}{' '}
        {lastUpdateDate
          ? format(new Date(lastUpdateDate), slashDateFormat)
          : null}
      </Typography>
    </Stack>
  );
};
